import React from 'react'
import TonalChip from './components/TonalChip'

// Same tonal status chip as the Analysis History table: in progress = info,
// done = success, failed = error, needs action = warning, queued = neutral.
const JobStateStatus = function ({ status = 'PENDING', isAnalysis = false }) {
  const { color, label } = {
    VERIFYING: { color: 'info', label: 'Verifying' },
    NOT_VERIFIED: { color: 'error', label: 'Not verified' },
    PENDING: { color: 'neutral', label: isAnalysis ? 'In queue' : 'Ready to process' },
    RUNNING: { color: 'info', label: 'Processing' },
    DONE: { color: 'success', label: 'Analyzed' },
    FAILED: { color: 'error', label: 'Failed' },
    UNKNOWN: { color: 'error', label: 'Unknown' },
    WAITING: { color: 'warning', label: 'Annotation required' },
    SINGLE_FASTQ: { color: 'warning', label: 'Needs pair' },
    ANNO_PENDING: { color: 'neutral', label: 'Annotation in queue' },
    ANNO_RUNNING: { color: 'info', label: 'Annotation processing' },
    ANNO_FAILED: { color: 'error', label: 'Annotation failed' },
  }[status] || { color: 'neutral', label: status }

  return <TonalChip tone={color} label={label} dot />
}

export default JobStateStatus
